<script>
import api from '@/api';

export default {
  name: 'Background',
  props: ['loading', 'image'],
  data() {
    return {
      previousRegion: '',
      defaultImages: {}
    };
  },
  watch: {
    $route (to, from) {
      const region = this.getRegion();
      this.loadDefaultBackground(region);
    },
    image() {
      this.setBackgroundImage();
    }
  },
  methods: {
    loadDefaultBackground(region, originalRegion) {
      if (this.previousRegion === region) {
        return;
      }

      this.previousRegion = this.getRegion();

      api
        .getMainArticlesNew(region)
        .then(entries => {
          const total = entries.data.items.length;

          if (total > 0) {
            entries = entries.data;
            let bgimage = '';

            // disable the following line for error and webhook(slack) testing
            let resItem = entries.items[entries.items.length - 1].fields;

            // handle background image
            if (resItem.backgroundImage) {
              let bgId = resItem.backgroundImage.sys.id;
              this.loadBackgroundImage(bgId, region, originalRegion);
            } else if (region !== '/verband') {
              this.loadDefaultBackground('/verband', region);
            } else {
              this.setBackgroundImage();
            }
          } else {
            console.error('no latest article available');
            this.$setBackground();
          }
        })
        .catch(error => {
          // console.log(error);
          api.errorHandling(error, `background.vue @ ${window.location.href}`);
        });
    },
    loadBackgroundImage(pageId, region, originalRegion) {
      if (pageId && region) {
        api
          .getBackgroundImageNew(pageId)
          .then(entries => {
            const saveForRegion = originalRegion ? originalRegion : region;
            this.defaultImages[saveForRegion] = entries.data.items[0].fields.file.url;
            this.setBackgroundImage();
          })
          .catch(error => {
            // console.log(error);
            api.errorHandling(
              error,
              `background.vue -> loadBackgroundImage @ ${window.location.href}`
            );
          });
      }
    },
    getRegion() {
      let region = this.$route.params.region || 'verband';
      if (region) {
        region = `/${region.toLowerCase()}`;
      }
      return region;
    },
    setBackgroundImage() {
      const region = this.getRegion();

      if (this.loading) {
        return;
      }

      if (this.image) {
        return this.$setBackground(true, this.image);
      }

      if (this.defaultImages[region]) {
        return this.$setBackground(true, this.defaultImages[region]);
      }

      this.$setBackground(true);
    }
  },
  render() {}
};
</script>



// WEBPACK FOOTER //
// src/components/includes/Background.vue